'use client'

import { useLoadingStore } from '@/stores/useLoadingStore'
import { Loader2 } from 'lucide-react'

export function GlobalLoadingBar() {
  const { isLoading, message } = useLoadingStore()

  if (!isLoading) return null

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
      <div className="flex items-center justify-center gap-3 px-4 py-3">
        <Loader2 className="w-5 h-5 text-blue-600 animate-spin" />
        <p className="text-sm font-medium text-gray-700">
          {message || '로딩 중...'}
        </p>
      </div>
      {/* 진행 바 애니메이션 */}
      <div className="h-1 bg-blue-100 overflow-hidden relative">
        <div className="h-full bg-blue-600 absolute inset-0 animate-[slide_1.5s_ease-in-out_infinite]" />
      </div>
      <style jsx global>{`
        @keyframes slide {
          0% {
            transform: translateX(-100%);
          }
          50% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(100%);
          }
        }
      `}</style>
    </div>
  )
}

